'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

function getResponseMetaData(response) {
  const headers = response.headers;
  const blob = response.data;
  const contentType = headers.get('content-type');
  const contentDisposition = headers.get('content-disposition');
  const filename = contentDisposition?.split(';')[1]?.split('filename')[1]?.split('=')[1]?.replaceAll('"', '')?.trim();

  return { blob, filename, contentType };
}

function getFileFromBlob(blobPart, fileName, contentType) {
  if (!fileName || !contentType) {
    return;
  }

  const blob = new Blob([blobPart], { type: contentType });
  const file = new File([blob], fileName);

  return file;
}

function downloadFile(file) {
  const fileName = file.name;

  // For IE
  if (navigator.appVersion.toString().indexOf('.NET') > 0) {
    window.navigator.msSaveOrOpenBlob(file, fileName);
  } else {
    const link = document.createElement('a');

    link.style.display = 'none';
    link.href = window.URL.createObjectURL(file);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    // For Firefox, we need to postpone the removal of the link
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      link.remove();
    }, 0)
  }
}


angular.module('services.attachments', [])

.factory('attachmentService', ['$http', '$q', '$upload', function ($http, $q, $upload) {

    var baseUrl = environment.apiUrl + '/Pilot/Attachment/',
        service = {};

    service.uploadFile = function (file) {
        return $upload.upload({
            url: baseUrl + 'Upload',
            method: 'POST',
            data: {},
            file: file
        }).then(function (response) {
            return response.data;
        });
    };

    service.uploadSelectedFiles = function (files, events, attachments) {

        return $q.all(_.map(files, function (file) {
            return service
                .uploadFile(file)
                .then(function (data) {
                    if (_.isArray(attachments)) {
                        attachments.push(data);
                    }
                });
        }));
    };

    service.uploadImage = function (file) {
        return $upload.upload({
            url: baseUrl + 'Image/Upload',
            method: 'POST',
            data: {},
            file: file
        }).then(function (response) {
            return response.data;
        });
    };

    service.downloadFile = function (id) {
      $http({
        method: 'GET',
        url: service.getDownloadUrl(id),
        responseType: 'blob'
      }).then(function (response) {
        const { blob, filename, contentType } = getResponseMetaData(response);
        if (blob && filename && contentType) {
          const file = getFileFromBlob(blob, filename, contentType);
          downloadFile(file);
        } else {
          console.error('Download error : ', { blob, filename, contentType });
        }
      });
    };

    service.downloadPhysicalFile = function(url, filename) {
      return $http({
        method: 'GET',
        url: url,
        responseType: 'blob'
      }).then(function (response) {
        const file = getFileFromBlob(response.data, filename, response.data.type);
        downloadFile(file);
      });
    };

    service.getBase64FromBlob = async function (response) {
      const blobToBase64 = blob => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
          reader.onloadend = () => {
            // @ts-ignore
            resolve(reader.result.split(',')[1].toString());
          };
        });
      };
      const base64 = await blobToBase64(response.data);
      return base64;
    };

    service.downloadBlob = function (id) {
      return $http({
        method: 'GET',
        url: service.getDownloadUrl(id),
        responseType: 'blob'
      });
    }



    service.getDownloadUrl = function (attachmentExternalId) {
        return baseUrl + 'Download/' + attachmentExternalId;
    };

    service.getViewUrl = function (attachmentExternalId) {
        return baseUrl + 'View/' + attachmentExternalId;
    };

    service.delete = function (externalId) {
        return $http.delete(baseUrl + externalId)
                    .then(function (response) {
                        return response.data;
                    });
    };

    return service;
}]);
